import React, { useState, useEffect } from 'react';
import Episode from './Episode';
import { useDispatch, useSelector } from 'react-redux';
import { setEpisodeListModule } from '../../redux/stopmodule/stopModuleSlice';
import { ContentTitle } from '../ui/styled';
import { dateFormat, EPISODE_LIST_URL } from '../../constants';
import moment from 'moment';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import { Auth } from 'aws-amplify';
import { getStopApi } from '../../services/StopApi/StopApi';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import { getReferralReferenceData } from '../../redux/episode/referralTab/referralReferenceSlice';
import { getProfA1ReferenceData } from '../../redux/episode/profA1Tab/profA1ReferenceSlice';
import { getProfA2ReferenceData } from '../../redux/episode/profA2Tab/profA2ReferenceSlice';
import { getProfB1ReferenceData } from '../../redux/episode/profB1Tab/profB1ReferenceSlice';
import { getProfB2ReferenceData } from '../../redux/episode/profB2Tab/profB2ReferenceSlice';
import { getActivitiesReferenceData } from '../../redux/episode/activitiesTab/activitiesReferenceSlice';
import { getAorcmReferenceData } from '../../redux/episode/aorvmTab/aorcmReferenceSlice';
import { getQualityAssuranceReferenceData } from '../../redux/episode/qualityAssuranceTab/qualityAssuranceReferenceSlice';
import { getStsAlertReferenceData } from '../../redux/episode/stsAlertTab/stsAlertReferenceSlice';
import { setIsReferralDataLoaded } from '../../redux/episode/referralTab/referralFormSlice';
import { setIsProfA1DataLoaded } from '../../redux/episode/profA1Tab/profA1FormSlice';
import { setIsProfB1DataLoaded } from '../../redux/episode/profB1Tab/profB1FormSlice';
import { setIsProfA2DataLoaded } from '../../redux/episode/profA2Tab/profA2FormSlice';
import { setIsProfB2DataLoaded } from '../../redux/episode/profB2Tab/profB2FormSlice';
import { setRefreshEpisodeParticipant } from '../../redux/episode/episodeParticipant/episodeParticipantSlice';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

const EpisodeList = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [searchEpisodeList, setSearchEpisodeList] = useState('');
  const [episodeListData, setEpisodeListData] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
    sortModel: '',
  });

  useEffect(() => {
    dispatch(setEpisodeListModule({ moduleName: 'episodeList', show: true }));
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    episodeListData.pageSize,
    episodeListData.page,
    episodeListData.sortModel,
    searchEpisodeList,
  ]);

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchReferenceData();
    }
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const fetchReferenceData = async () => {
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(getReferralReferenceData(authorization));
    dispatch(getProfA1ReferenceData(authorization));
    dispatch(getProfA2ReferenceData(authorization));
    dispatch(getProfB1ReferenceData(authorization));
    dispatch(getProfB2ReferenceData(authorization));
    dispatch(getActivitiesReferenceData(authorization));
    dispatch(getAorcmReferenceData(authorization));
    dispatch(getQualityAssuranceReferenceData(authorization));
    dispatch(getStsAlertReferenceData(authorization));
  };

  const fetchData = async () => {
    setEpisodeListData((old) => ({ ...old, isLoading: true }));
    const commonParams = commonQueryParams(
      EPISODE_LIST_URL,
      searchEpisodeList,
      episodeListData
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    dispatch(setIsReferralDataLoaded(false));
    dispatch(setIsProfA1DataLoaded(false));
    dispatch(setIsProfB1DataLoaded(false));
    dispatch(setIsProfA2DataLoaded(false));
    dispatch(setIsProfB2DataLoaded(false));
    dispatch(setRefreshEpisodeParticipant(false));
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setEpisodeListData((old) => ({
        ...old,
        isLoading: false,
        total: response?.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: item.episodeID ? item.episodeID : '',
          episodeID: item.episodeID ? item.episodeID : '',
          episodeSAPStartDate: item.episodeSAPStartDate
            ? moment(item.episodeSAPStartDate).format(dateFormat).split('T')[0]
            : '',
          expectedEPRD: item.expectedEPRD
            ? moment(item.expectedEPRD).format(dateFormat).split('T')[0]
            : '',
          prisonRelease: item.prisonRelease
            ? moment(item.prisonRelease).format(dateFormat).split('T')[0]
            : '',
          reg: item.reg ? item.reg : '',
          referralSource: item.referralSource
            ? item.referralSource?.value
            : '',
          paroleCounty: item.paroleCounty ? item.paroleCounty?.value : '',
          paroleCountyId: item.paroleCounty ? item.paroleCounty?.id : '',
          paroleOfficer: item.paroleOfficer ? item.paroleOfficer?.value : '',
          episodeDischargeDate: item.episodeDischargeDate
            ? moment(item.episodeDischargeDate).format(dateFormat).split('T')[0]
            : '',
          episodeDischargeReason: item.EpisodeDischargeReason
            ? item.EpisodeDischargeReason?.value
            : '',
          cDCNumber: item.cDCNumber ? item.cDCNumber : '',
          cCCMS: item.cCCMS,
          key: item.participant ? item.participant?.key : '',
          participantId: item.participant ? item.participant?.id : '',
          registration290: item.participant.registration290,
          inactive: item.participant.inactive,
        })),
      }));
    }).catch((e) => alert(e));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const episodeListAdditionalHeaders = useSelector(
    (state) => state?.stopModulesData?.toEpisodeList
  );
  return (
    <>
      <ContentTitle container>
        <Grid item xs={4}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title='Episodes' />
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box style={{ alignItems: 'center' }}>
            <Typography variant='h4' align='center'>Episodes</Typography>
          </Box>
        </Grid>
      </ContentTitle>
      <Episode
        episodeList={episodeListAdditionalHeaders}
        episodeListData={episodeListData}
        setEpisodeListData={setEpisodeListData}
        searchEpisodeList={searchEpisodeList}
        setSearchEpisodeList={setSearchEpisodeList}
      />
    </>
  );
};
export default EpisodeList;
